import React from "react";
import { Box, Stack } from "@origin-digital/ods-core";
import { Skeleton } from "@origin-digital/ods-lab";

const PARAGRAPH_LINE_WIDTHS = ["100%", "100%", "64%"] as const;

export const ContentSkeleton: React.FC = () => (
  <Stack space="xxlarge" data-id="article-content-skeleton">
    <Box marginTop="medium">
      <Skeleton
        data-id="article-content-skeleton-title"
        variant="rounded"
        width="73%"
        height={40}
        backgroundColor="light"
      />
    </Box>
    <Skeleton
      data-id="article-content-skeleton-feature"
      variant="rounded"
      width="100%"
      height={196}
      backgroundColor="light"
    />
    <Stack space="large">
      <Skeleton
        data-id="article-content-skeleton-heading"
        variant="rounded"
        width="73%"
        height={40}
        backgroundColor="light"
      />
      {PARAGRAPH_LINE_WIDTHS.map((width, index) => (
        <Skeleton
          key={index}
          data-id={`article-content-skeleton-line-${index + 1}`}
          variant="rounded"
          width={width}
          height={22}
          backgroundColor="light"
        />
      ))}
    </Stack>
  </Stack>
);
